import React, { Component } from 'react';
import Widget from '../common/Widget';
import { Stack, Link, Typography, Box, Alert, AlertTitle, Skeleton } from '@mui/material';
import { Container, Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import WithRouter from '../Layout/Router/WithRouter';
import PortalLink from '../common/PortalLink';

class MyRegistration extends Component {
  state = {
    title: ['my', 'Registration'],
    days: '--',
    hours: '--',
    minutes: '--',
    seconds: '--',
    countdownStartDateTime: '',
    currentTime: '',
    openRegistrationStart: new Date('2026-04-01T08:00:00'), // 8AM April 1
    futureSemester: 'Fall 2026',
  };

  componentDidMount = () => {
    const countdownStartDateTime = new Date(this.state.openRegistrationStart);
    this.setState({
      countdownStartDateTime,
      currentTime: new Date().getTime(),
    });
    this.calculateCountDownTime(countdownStartDateTime);
    this.countDownInterval = setInterval(() => {
      this.updateCountDownTime();
    }, 1000);
  };

  titleCase = (str) => {
    return str
      .toLowerCase()
      .split(' ')
      .map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  };

  calculateCountDownTime = (startTime) => {
    const currentTime = new Date().getTime();
    const distanceToDate = startTime - currentTime;
    let days = Math.floor(distanceToDate / (1000 * 60 * 60 * 24));
    let hours = Math.floor((distanceToDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((distanceToDate % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distanceToDate % (1000 * 60)) / 1000);
    this.setState({ days, hours, minutes, seconds });
  };

  updateCountDownTime = () => {
    if (this.state.countdownStartDateTime) {
      let updatedSeconds = Number(this.state.seconds) - 1;
      if (updatedSeconds < 0) {
        updatedSeconds = 59;
        this.setState({ seconds: updatedSeconds });
        let updatedMinutes = Number(this.state.minutes) - 1;
        if (updatedMinutes < 0) {
          updatedMinutes = 59;
          this.setState({ minutes: updatedMinutes });
          let updatedHours = Number(this.state.hours) - 1;
          if (updatedHours < 0) {
            updatedHours = 23;
            this.setState({ hours: updatedHours });
            let updatedDays = this.state.days - 1;
            if (updatedDays > 0) {
              this.setState({ days: updatedDays });
            }
          } else {
            this.setState({ hours: updatedHours });
          }
        } else {
          this.setState({ minutes: updatedMinutes });
        }
      } else {
        this.setState({ seconds: updatedSeconds });
      }
    }
  };

  componentWillUnmount = () => {
    clearInterval(this.countDownInterval);
  };

  render() {
    return (
      <React.Fragment>
        <Widget
          data={{
            id: this.props.widget.id,
            title: this.props.title,
            isTitleStylized: this.props.isTitleStylized,
            isExpand: this.props.widget.isExpand,
            isRequired: this.props.widget.isRequired,
          }}
          {...this.props}
          className="myOdu__myRegistration"
        >
          {this.props.statusAlerts?.holds?.length > 0 && (
            <div className="text-center mb-3">
              <Stack
                direction={{
                  xs: 'column',
                  sm: 'row',
                  md: 'column',
                  lg: 'row',
                  xl: 'column',
                  xxl: 'row',
                  xxxl: 'row',
                  xxxxl: 'row',
                }}
                sx={{
                  alignItems: { xs: 'center' },
                  justifyContent: {
                    xs: 'center',
                    lg: 'center',
                    xxl: 'center',
                    xxxl: 'center',
                    xxxxl: 'center',
                  },
                }}
              >
                <Typography
                  variant="small"
                  className="myOdu__textBadge cautionBadge"
                  sx={{ display: 'inline' }}
                >
                  Action Required
                </Typography>
                <Typography variant="small" sx={{ display: 'inline', ml: 1 }}>
                  You have{' '}
                  <PortalLink
                    onClick={() => this.props.navigate('/statusAlerts')}
                    underline="always"
                    sx={{ cursor: 'pointer' }}
                    className="noIcon"
                  >
                    {this.props.statusAlerts.holds.length}{' '}
                    {this.props.statusAlerts.holds.length > 1 ? 'holds' : 'hold'} on your account
                  </PortalLink>
                  .
                </Typography>
              </Stack>
            </div>
          )}
          <>
            {/* If open registration has not started yet show the countdown */}
            {this.state.countdownStartDateTime >= this.state.currentTime && (
              <Box className="wrapper" sx={{ m: 0, textAlign: 'center' }}>
                <Stack
                  sx={{ mb: 2 }}
                  direction={{
                    xxl: 'row',
                    xl: 'column',
                    lg: 'row',
                    md: 'row',
                    sm: 'row',
                    xs: 'row',
                  }}
                  justifyContent={'center'}
                  alignContent={'center'}
                  alignItems={'center'}
                >
                  <Typography
                    variant="small"
                    component="h3"
                    sx={{
                      fontWeight: 600,
                      textAlign: 'left',
                      justifyContent: 'left',
                    }}
                  >
                    {this.state.futureSemester}{' '}
                    <PortalLink
                      target="_blank"
                      href="https://reg-prod.ec.odu.edu/StudentRegistrationSsb/ssb/registration"
                      underline="always"
                      className="noIcon"
                    >
                      open registration
                    </PortalLink>{' '}
                    begins for all students in{' '}
                  </Typography>
                </Stack>
                <Container>
                  <Row>
                    <Col xs={3} className="ps-0">
                      <Stack alignItems="center" justifyContent="center" className="myOdu__border">
                        <Typography variant="h3" component="p">
                          {this.state.days}
                        </Typography>
                        <Typography
                          sx={(theme) => ({
                            [theme.breakpoints.only('xs')]: {
                              fontSize: '0.65rem',
                            },
                          })}
                          variant="smaller"
                          component="p"
                        >
                          Days
                        </Typography>
                      </Stack>
                    </Col>
                    <Col xs={3} className="ps-0">
                      <Stack alignItems="center" justifyContent="center" className="myOdu__border">
                        <Typography variant="h3" component="p">
                          {this.state.hours}
                        </Typography>
                        <Typography
                          sx={(theme) => ({
                            [theme.breakpoints.only('xs')]: {
                              fontSize: '0.65rem',
                            },
                          })}
                          variant="smaller"
                          component="p"
                        >
                          Hours
                        </Typography>
                      </Stack>
                    </Col>
                    <Col xs={3} className="ps-0">
                      <Stack alignItems="center" justifyContent="center" className="myOdu__border">
                        <Typography variant="h3" component="p">
                          {this.state.minutes}
                        </Typography>
                        <Typography
                          sx={(theme) => ({
                            [theme.breakpoints.only('xs')]: {
                              fontSize: '0.65rem',
                            },
                          })}
                          variant="smaller"
                          component="p"
                        >
                          Minutes
                        </Typography>
                      </Stack>
                    </Col>
                    <Col xs={3} className="ps-0 pe-0">
                      <Stack alignItems="center" justifyContent="center" className="myOdu__border">
                        <Typography variant="h3" component="p">
                          {this.state.seconds}
                        </Typography>
                        <Typography
                          sx={(theme) => ({
                            [theme.breakpoints.only('xs')]: {
                              fontSize: '0.65rem',
                            },
                          })}
                          variant="smaller"
                          component="p"
                        >
                          Seconds
                        </Typography>
                      </Stack>
                    </Col>
                  </Row>
                </Container>
                <Typography
                  variant="small"
                  component="p"
                  sx={{
                    textAlign: 'left',
                    justifyContent: 'left',
                    mt: 1,
                  }}
                >
                  Select students may register early. See{' '}
                  <PortalLink
                    target="_blank"
                    href="https://www.odu.edu/registration/when-to-register"
                    underline="always"
                    className="noIcon"
                  >
                    When to Register
                  </PortalLink>{' '}
                  for details.
                </Typography>
              </Box>
            )}

            {/* ELSE, say that open registration is already available */}
            {!(this.state.countdownStartDateTime >= this.state.currentTime) && (
              <Box className="wrapper" variant="smaller" sx={{ m: 0, textAlign: 'center' }}>
                <Stack
                  direction={{
                    xxl: 'row',
                    xl: 'column',
                    lg: 'row',
                    md: 'row',
                    sm: 'row',
                    xs: 'row',
                  }}
                  justifyContent={'center'}
                  alignContent={'center'}
                  alignItems={'center'}
                >
                  <div
                    style={{
                      width: '50px',
                      height: '50px',
                    }}
                    className="me-xxl-1 me-xl-0 me-lg-1 me-md-1 me-sm-1 me-1"
                  >
                    <img src="img/logos/registration.svg" alt="registration" />
                  </div>
                  <div>
                    <Typography variant="small" component="h3" sx={{ fontWeight: 600 }}>
                      Registration is Open!
                    </Typography>
                    <PortalLink
                      target="_blank"
                      href="https://reg-prod.ec.odu.edu/StudentRegistrationSsb/ssb/registration"
                      underline="always"
                      className="noIcon"
                      id={'myRegistration__link_registerForClasses'}
                    >
                      You may register for {this.state.futureSemester} classes
                    </PortalLink>
                    .
                  </div>
                </Stack>
              </Box>
            )}
          </>
        </Widget>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    statusAlerts: state.myStatusAlertsReducer.statusAlerts,
  };
};

export default connect(mapStateToProps)(WithRouter(MyRegistration));
